// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// import VCharts from 'v-charts';
import ElementUI from 'element-ui';
// import VeLine from 'v-charts/lib/line.common';
// import VeHistogram from 'v-charts/lib/histogram.common';
import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
import App from './App';
// import Mock from './mock';
import router from './router';
// import moment from 'moment';
// import store from './store';
// import Api from './api/api';

// Vue.prototype.$moment = moment;
Vue.config.productionTip = false;
// Vue.component(VeLine.name, VeLine);
// Vue.component(VeHistogram.name, VeHistogram);

Vue.use(ElementUI, {
  size: 'small'
});

// require('./mock/mock.js');
// Mock.bootstrap();

// function gotoLogin(next, redictPath) {
//   next({
//     path: '/login',
//     query: {
//       redirect: redictPath
//       // toPath: to.fullPath
//     }
//   });
// }

// router.beforeEach((to, from, next) => {
//   // if (!store.state.sysInited) {
//   //   store.dispatch('initSys');
//   // }
//   // console.log('to:', to, 'from:', from);
//    window.document.title = '系统';
  
//   // 检测路由配置中是否有requiresAuth这个meta属性
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     // 判断是否已登录
//     if (store.getters.isLoggedIn) {
//       next();
//     } else {
//       let bTokenIsvalid = false;
//       if (store.state.token && (store.state.token.length > 0)) {
//         Api.users.checkToken(store.state.token).then(res => {
//           // console.log('res: ', res);
//           if (res.success) {
//             // console.log('登录成功');
//             store.commit('auth_success', res.data);
//             bTokenIsvalid = true;
//             // console.log('redirect:', res.data);
//             // console.log('登录成功');
//           } else {
//             // console.log(res.msg || '登陆失败');
//           }
//         // }).catch(err => {
//           // console.log('redirect:', err);
//         }).finally(() => {
//           if (bTokenIsvalid) {
//             next();
//           } else {
//             gotoLogin(next, to.fullPath);
//           }
//         });
//       } else {
//         gotoLogin(next, to.fullPath);
//       }
//     }
//   } else {
//     next();
//   }
// });

new Vue({
  //  el: '#app',
  // store,
  router,
  render: h => h(App)
}).$mount('#app');


// WEBPACK FOOTER //
// ./src/main.js